import { MfaMethod } from 'types';
import { MfaMethodSelection } from '../../../organisms/mfa/mfaMethodSelection';
import MfaSmsIcon from '../../../atoms/mfa-sms-icon';
import MfaTotpIcon from '../../../atoms/mfa-totp-icon';

interface Props {
  onSelectTOTP: () => void;
  onSelectSMS: () => void;
  onSkip: () => void;
}

const getOptions = (onSelectTOTP: () => void, onSelectSMS: () => void) => {
  return [
    {
      key: MfaMethod.TOTP as string,
      id: MfaMethod.TOTP as string,
      onClick: onSelectTOTP,
      icon: <MfaTotpIcon />,
      content: <>Use an app to authenticate (recommended)</>
    },
    {
      key: MfaMethod.SMS as string,
      id: MfaMethod.SMS as string,
      onClick: onSelectSMS,
      icon: <MfaSmsIcon />,
      content: <>Send a code to a phone number</>
    }
  ];
};

function mfaSetup(props: Props) {
  return <MfaMethodSelection options={getOptions(props.onSelectTOTP, props.onSelectSMS)} onSkip={props.onSkip} />;
}
export default mfaSetup;
